import * as yup from "yup";
import { DemonstrationFormValues } from "./interfaces";

export const initialValues: DemonstrationFormValues = {
  email: "",
  privacyPolicy: false,
};

export const validationSchema = (): yup.SchemaOf<DemonstrationFormValues> =>
  yup.object().shape({
    email: yup.string().email().required(),
    privacyPolicy: yup.bool().required().oneOf([true], " "),
  });
